// extracted by extract-css-chunks-webpack-plugin
module.exports = {"xs":"667.98","sm":"947.98","md":"1023.98","lg":"1229.98","container":"suBTKucY","containerPadded":"RAoY4UQh","pages":"_23NJHzpg","aside":"_7gshJC0N","btn":"hfgXXs23"};